import React from "react";
import styled from "styled-components";
import InputField, { InputFieldProps } from "./InputField.tsx";

// Define the props using an interface

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

const Button = styled.button`
  margin-top: 1rem;
  border-radius: 20px;
  border: 1px solid var(--primary-green);
  background-color: var(--secondary-green);
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;

  cursor: pointer;
`;

interface Props {
  formId: string;
  saveButtonLabel: string;
  fields: InputFieldProps[];
  onSave: (data: any) => void;
  width?: string;
}
const FormComponent: React.FC<Props> = ({
  onSave,
  saveButtonLabel,
  fields,
  formId,
  width,
}) => {
  return (
    <Form
      style={{ width: width || "100%" }}
      id={formId}
      onSubmit={(e: React.FormEvent) => {
        e.preventDefault();
        const form = new FormData(e.target as HTMLFormElement);
        const formData = Object.fromEntries(form.entries());
        onSave(formData);
      }}
    >
      {fields.map((field, index) => (
        <InputField key={index} {...field} />
      ))}
      <Button type="submit">{saveButtonLabel}</Button>
    </Form>
  );
};

export default FormComponent;
